'use strict'
import { Toast } from 'vant'

const PARENT_KEY = 'parentId'
const MUTEX_KEY = 'mutexId'
let projectAll = []

/**
 * project 体检项目对象属性说明
 *
 * id 体检项目ID
 * item 体检项目名称
 * inspectionSignificance 体检项目简介
 * mutexCode 体检项目互斥组CODE,多个以","相隔
 * mutexId 体检项目互斥组ID,多个以","相隔
 * addWarning 是否显示特别说明  1 有  0 没有
 * warningInfo 体检项目特别说明内容
 * discountPrice 折后价格
 * price 价格
 * orderNum 排序号
 * parentId 父级ID,以此构建树状结构
 * parentName 父级名称
 * recalculate 是否可替换 1 可替换 0 不可替换
 * relationships 体检项目的关联项目ID ,多个以","相隔(存在materialList中)
 * typable 数据类型 0 父级目录 1 体检项目
 *
 * packable 是否为当前已选择体检套餐包含的项目 1 已存在套餐中 0 未存在套餐中
 * recommendable 是否为推荐体检项目 1 推荐项目 0 普通项目
 *
 * base 是否为基础项目 1 基础项目 0 普通项目
 * 以下属性只有基础项目才有:
 * revoke 撤销操作标识,1 允许撤销 0 禁止撤销
 * delectable 是否可删除 1 可删除 0 不可删除
 */

function unCheckProject (project, allProjectList, checkedProjectList, mutexProjectList, projectMutexAll, materialListAll, replacedList) {
  if (!projectAll.length) projectAll = allProjectList
  let projectList = []
  if ((project.packable === 1 || project.base === 1) && (project.replaceable !== '1' || project.delectable !== '1')) {
    // 如果当前体检项目是基础想,并且不可替换或不可删除,则直接返回
    return checkedProjectList
  }
  projectList = checkedProjectList.filter((p) => {
    //从已选择项目集合中取消当前选择项目
    return project.id !== p.id
  })
  let mUTexProject = getMutexProjectRelation(project, allProjectList, projectMutexAll)
  let relevanceList = getMaterialProjectList([project], materialListAll, mUTexProject, []) || []
  relevanceList.push(project)
  relevanceList.forEach(obj => {
    if (obj.recalculate.toString() === '0' && obj[MUTEX_KEY]) {
      let objMUTEX = getMutexProjectRelation(obj, allProjectList, projectMutexAll)
      if (objMUTEX && objMUTEX.length > 0) { // 如果当前体检项目所在互斥组中有基础项目
        objMUTEX.forEach(p => {
          if (p.packable !== 1 && p.base === 1 && !checkedProjectList.some(pr => p.id === pr)) {
            let isMUTexProject = getMutexProjectRelation(p, allProjectList, projectMutexAll)
            // 需处理自动选择的基础项目所在互斥组的互斥项目
            // console.log(projectList.some(obj => { return isMUTexProject.some($project => { return $project.id === obj.id }) }), projectList, isMUTexProject)
            if (!isMUTexProject.length || (!projectList.some(obj => { return isMUTexProject.some($project => { return $project.id === obj.id }) }) && !projectList.some(obj => { return p.id == obj.id }))) {
              projectList.push(p)
              projectList = checkProject(p, allProjectList, projectList, isMUTexProject, projectMutexAll, materialListAll, replacedList)
            }
          }
        })
      }
    }
  })

  return projectList
}

function checkProject (project, allProjectList, checkedProjectList, mutexProjectList, projectMutexAll, materialListAll, replacedList) {
  if (!projectAll.length) projectAll = allProjectList
  let projectList = []
  let allMaterial = getMaterialProjectList(checkedProjectList, materialListAll, projectMutexAll, [])
  let nowMutex = []
  if (!replacedList.length) {
    (allMaterial.concat(checkedProjectList)).forEach(obj => {
      if (obj.mutexId) {
        nowMutex = nowMutex.concat(getMutexProjectRelation(obj, allProjectList, projectMutexAll))
      }
    })
  }
  if (mutexProjectList && mutexProjectList.length > 0) {
    let uncheckProjectList = []
    let stateCode = true
    projectList = [].concat(checkedProjectList)
    for (let mutexProject of mutexProjectList) {
      if (!replacedList.some(obj => { return obj.id === mutexProject.id && (mutexProject.base === 1 || mutexProject.packable === 1) }) && !nowMutex.some(obj => { return obj.id === mutexProject.id && (mutexProject.base === 1 || mutexProject.packable === 1) })) {
        if ((mutexProject.base === 1 || mutexProject.packable === 1) && mutexProject.replaceable !== '1') {
          Toast.fail({
            duration: 3000,
            forbidClick: true,
            message: `该项目与${mutexProject.packable === 1 ? '套餐' : '基础项目包'}中的【${mutexProject.item}】项目不能同时选择`
          })
          return projectList
        } else if (mutexProject.packable === 1 && mutexProject.replaceable === '1' && project.price < mutexProject.discountPrice) {
          Toast.fail({
            duration: 2500,
            forbidClick: true,
            message: `该项目与${mutexProject.packable === 1 ? '套餐' : '基础项目包'}中的【${mutexProject.item}】项目不能同时选择`
          })
          return projectList // 互斥组中包含套餐项目,并且套餐项目为可替换,如果当前选择项目价格低于套餐项目,则不可操作
        } else if (checkedProjectList.some(p => p.id === mutexProject.id)) {
          if ((mutexProject.base === 1 || mutexProject.packable === 1) && mutexProject.replaceable === '1') {
            uncheckProjectList.push(mutexProject)
          } else if (mutexProject.base !== 1 && mutexProject.packable !== 1) {
            uncheckProjectList.push(mutexProject)
          }
        } else if (allMaterial && allMaterial.some(p => { return p.id === mutexProject.id })) { //&& p.price > project.price
          stateCode = false
        }
      }
    }
    projectList = projectList.filter((p) => !uncheckProjectList.some((sp) => p.id === sp.id))
    if (!checkedProjectList.some(p => { return p.id === project.id }) && project.packable !== 1 && stateCode) {
      // console.log(project)
      projectList = projectList.concat([project])
    }
  } else if (!checkedProjectList.some(p => p.id === project.id)) {
    projectList = project.packable !== 1 ? checkedProjectList.concat([project]) : checkedProjectList
  }
  let relevanceList = getMaterialProjectList([project], materialListAll, projectMutexAll, []) || []
  relevanceList.forEach(obj => {
    let mUTexProject = getMutexProjectRelation(obj, allProjectList, projectMutexAll)
    // console.log(mUTexProject, obj)
    if (mUTexProject && mUTexProject.length) {
      mUTexProject.forEach(project => {
        // console.log(JSON.parse(JSON.stringify(projectList)))
        // console.log(project.replaceable === '1', projectList.some(pr => { return project.id === pr.id && obj.price > pr.price }), project)
        if (project.replaceable === '1' && projectList.some(pr => { return project.id === pr.id && obj.price > pr.price })) {
          // console.log(project)
          projectList = projectList.filter(item => { return item.id !== project.id })
        }
      })
    }
  })
  return projectList
}

function getCheckedProjectList (project, allProjectList, checkedProjectList, projectMutexAll, materialListAll, replacedList) {
  let projectList = []
  let mutexProjectList = getMutexProjectRelation(project, allProjectList, projectMutexAll)
  if (checkedProjectList.some(p => p.id === project.id)) {
    // 取消选项,并处理互斥组关系
    projectList = unCheckProject(project, allProjectList, checkedProjectList, mutexProjectList, projectMutexAll, materialListAll, replacedList)
  } else {
    // 添加项目
    projectList = checkProject(project, allProjectList, checkedProjectList, mutexProjectList, projectMutexAll, materialListAll, replacedList)
  }
  return projectList
}

function getMutexProjectRelation (project, projectList, projectMutexAll) {
  // console.log(project, projectList, projectMutexAll)
  let projects
  let mutexIds = []
  let mutexProjectList = []
  if (project.mutexId && typeof project.mutexId === 'string') {
    mutexIds = project.mutexId.split(',') || []
  }
  for (let id of mutexIds) {
    projects = getMutexProjectList(projectList, id, project, projectMutexAll)
    for (let obj of projects) {
      if (obj.mutexId && project.id !== obj.id && !mutexProjectList.find((p) => p.id === obj.id)) {
        mutexProjectList.push(obj)
      }
    }
  }
  return mutexProjectList
}

function getMaterialProjectList (checkedProjectList, materialList, projectMutexList, nMaterialProjectList, productList) {
  let materialProjectList = []
  let materialIds, materialProject
  let addCompleted = []
  checkedProjectList = JSON.parse(JSON.stringify(checkedProjectList))
  if (productList && productList.length) {
    productList.forEach(obj => obj.id = obj.projectId)
    checkedProjectList = productList.concat(checkedProjectList)
  }
  for (let checkedProject of checkedProjectList) {
    // console.log(checkedProject)
    addCompleted.push(checkedProject.id)
    //当前项目不能关联项目不包含
    if (checkedProject.relationships && typeof checkedProject.relationships === 'string') {
      materialIds = checkedProject.relationships.split(',') || []
      if (checkedProject.projectRelationshipDtoList && checkedProject.projectRelationshipDtoList.length) {
        checkedProject.projectRelationshipDtoList.forEach(obj => {
          if (obj.projectId.split(',').some($item => { return $item !== checkedProject.id && addCompleted.includes($item) })) {
            materialIds = materialIds.filter($item => { return !obj.relationshipId.split(',').some($p => { return $p.split('*').includes($item) }) })
          } else if (nMaterialProjectList && nMaterialProjectList.length && obj.projectId.split(',').some($item => { return nMaterialProjectList.some($t => { return $t && $t.id === $item }) })) {
            materialIds = materialIds.filter($item => { return !obj.relationshipId.split(',').some($p => { return $p.split('*').includes($item) }) })
          }
        })
      }
      materialIds = materialIds.filter(obj => { return !checkedProjectList.some(item => { return (item.id === obj || ((item.relationships && item.relationships.split(',').includes(obj) && item.id !== checkedProject.id) && addCompleted.includes(obj))) && (!materialList || materialList.some(p => { return p.id === obj && p.recalculate.toString() === '0' })) && (!nMaterialProjectList || !nMaterialProjectList.some(item => { return item && (item.id === obj || (item.relationships && item.relationships.split(',').includes(obj) && item.id !== checkedProject.id)) && (!materialList || materialList.some(p => { return p.id === obj && p.recalculate.toString() === '0' })) })) }) })
      // console.log(materialIds)
      for (let id of materialIds) {
        if (checkedProjectList.some(p => p.id === id)) {
          continue
        }
        // console.log(materialList)
        if (materialList) {
          materialProject = materialList.find((p) => p.id === id)
          if (materialProject) {
            let code = true
            if (materialProject[MUTEX_KEY]) {
              let mutex = getMutexProjectRelation(materialProject, projectAll, projectMutexList)
              mutex.forEach(obj => {
                if ((materialProjectList.some(item => { return item.id === obj.id }) || checkedProjectList.some(item => { return item.id === obj.id })) && code) {
                  if (materialProject.price > obj.price) {
                    if (checkedProjectList.some(item => { return item.id === obj.id })) {
                      checkedProjectList.splice(checkedProjectList.findIndex(item => { return item.id === obj.id }), 1)
                    } else {
                      materialProjectList.splice(materialProjectList.findIndex(item => { return item.id === obj.id }), 1)
                    }

                    materialProjectList.push(materialProject)
                  }
                  code = false
                } else if (materialProjectList.some(item => { return item.id === obj.id }) || checkedProjectList.some(item => { return item.id === obj.id })) {
                  code = false
                }
              })
            } else if (!materialProject.relationships && code && (materialProject.recalculate === 1 || !materialProjectList.some(obj => { return obj.id === materialProject.id }))) {
              // console.log(materialProject)
              materialProjectList.push(materialProject)
            }

            if (!materialProjectList.some(item => { return item.id === materialProject.id }) && (!nMaterialProjectList || !nMaterialProjectList.some(item => { return item.id === materialProject.id })) && !checkedProjectList.some(item => { return item.id === materialProject.id }) && code) {
              // console.log(materialProject)
              if (materialProject.relationships) {
                var arrNew = []
                arrNew.push(materialProject)
                let isProject = JSON.parse(JSON.stringify(checkedProjectList))
                if (nMaterialProjectList && nMaterialProjectList.length) {
                  isProject = isProject.concat(nMaterialProjectList)
                }
                // console.log(getMaterialProjectList(arrNew, materialList, projectMutexList, isProject, productList))
                getMaterialProjectList(arrNew, materialList, projectMutexList, isProject, productList).map(item => {
                  materialProjectList.push(item)
                })
                materialProjectList.push(materialProject)
              } else {
                materialProjectList.push(materialProject)

                // console.log(JSON.parse(JSON.stringify(materialProjectList)))
              }
            }
          }
        }
      }
    }
  }
  return materialProjectList
}

function getClassListByProject (project, projectClassList) {
  let items = []
  for (let type of projectClassList) {
    for (let item of type.items) {
      if (item.id === project.id || item.projectId === project.id) {
        items.push(type.id)
        break
      }
    }
  }
  return items.join(',')
}

function getProjectTreeList (projectList) {
  return getTreeListByOrderNum(projectList, '', PARENT_KEY)
}

function getMutexProjectList (projectList, id, project, projectMutexAll) {
  let mutexProjectList = []
  if (projectMutexAll[id]) {
    for (let key in projectMutexAll[id]) {
      if (projectMutexAll[id][project.id] === 1 && key !== project.id) {
        mutexProjectList.push(key)
      } else if (projectMutexAll[id][project.id] === 0 && projectMutexAll[id][key] === 1) {
        mutexProjectList.push(key)
      }
    }
  }
  return projectList.filter(obj => { return mutexProjectList.includes(obj.id) })
}

/**
 * 通过递归获取树形结构数据
 * @param list 数据集合
 * @param keyword 关系值
 * @param key 关系key
 * @param childrenKey 子集key(默认值：children)
 * @returns {Array} 符合要求的树形结构数据
 */
function getTreeList (list, keyword, key, childrenKey) {
  let array = []
  var isNotTypable = list.filter(obj => { return obj.typable !== '1' })
  for (let node of list) {
    if (node.hasOwnProperty(key) && (`,${node[key]},`).indexOf(`,${keyword},`) > -1) {
      if (node.typable === '1') {
        if (node.visible === null) {
          node[childrenKey || 'children'] = getTreeList(isNotTypable, node.id, key, childrenKey)
        } else {
          node[childrenKey || 'children'] = getTreeList(list, node.id, key, childrenKey)
        }
      }
      array.push(node)
    }
  }
  return array
}

/**
 * 通过递归获取树形结构数据
 * @param list 数据集合
 * @param keyword 关系值
 * @param key 关系key
 * @param childrenKey 子集key(默认值：children)
 * @returns {Array} 符合要求的树形结构数据
 */
function getTreeListByOrderNum (list, keyword, key, childrenKey) {
  let array = []
  let arr = list.filter(obj => { return obj.typable === '1' && obj.addWarning !== null })
  // console.log(arr)
  for (let node of arr) {
    if (node.hasOwnProperty(key) && (`,${node[key]},`).indexOf(`,${keyword},`) > -1) {
      node[childrenKey || 'children'] = getTreeList(list, node.id, key, childrenKey)
      node[childrenKey || 'children'] = node[childrenKey || 'children'].sort(function (a, b) {
        return ((a.orderNum < b.orderNum) ? -1 : ((a.orderNum > b.orderNum) ? 1 : 0))
      })
      array.push(node)
    }
  }
  return array
}

// function getTreeListByOrderNum (list, keyword, key, childrenKey) {
//   let array = []
//   for (let node of list) {
//     // console.log(list, '???????????????', node, keyword, key , childrenKey)
//     if (node.hasOwnProperty(key) && (`,${node[key]},`).indexOf(`,${keyword},`) > -1) {
//       node[childrenKey || 'children'] = getTreeList(list, node.id, key, childrenKey)
//       node[childrenKey || 'children'] = node[childrenKey || 'children'].sort(function (a, b) {
//         return ((a.orderNum < b.orderNum) ? -1 : ((a.orderNum > b.orderNum) ? 1 : 0))
//       })
//       array.push(node)
//     }
//   }
//   // console.log(array)
//   return array
// }

function replaceTree (projectList, isTreeList) {
  let arr = []
  isTreeList.forEach(obj => {
    // console.log(obj)
    if (obj.children && obj.children.length) {
      let {item, id, orderNum, parentId, parentName, inspectionSignificance} = obj
      let children = replaceTree(projectList, JSON.parse(JSON.stringify(obj.children)))
      // console.log(children, item)
      let showList = children.filter(project => { return project.visible === 1 })
      if (obj.isMutexGroupProject === 1) {
        if (showList.length) {
          arr.push({
            item: item.replace(/[0-9]+/, showList.length),
            id,
            orderNum,
            parentId,
            parentName,
            inspectionSignificance,
            children,
            typable: '1',
            visible: 1
          })
        } else {
          arr.push({
            item,
            id,
            orderNum,
            parentId,
            parentName,
            inspectionSignificance,
            children,
            typable: '1',
            visible: 0
          })
        }
      } else {
        arr.push({item, id, orderNum, parentId, parentName, inspectionSignificance, children, typable: '1', visible: 1})
      }
    } else {
      for (let i = 0; i < projectList.length; i++) {
        if (obj.id === projectList[i].id) {
          arr.push(projectList[i])
          break
        }
      }
    }
  })
  return arr
}

function getProjectMutexList (isTreeList) {
  let isMutex = {}
  isTreeList.forEach(obj => {
    if (obj.children && obj.children.length && obj.typable === '1') {
      Object.assign(isMutex, getProjectMutexList(obj.children))
    } else if (obj.children && obj.children.length) {
      let children = {}
      obj.children.forEach(project => {
        children[project.id] = project.exclusive
      })
      isMutex[obj.id] = children
    }
  })
  return isMutex
}

export default {
  getProjectTreeList,
  getProjectMutexList,
  getMutexProjectRelation,
  getMaterialProjectList,
  getCheckedProjectList,
  getClassListByProject,
  getTreeList,
  replaceTree
}
